import { Link } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { reachesCompany } from '@/auth/access'
import { sampleName } from './nameSample'
import { Card } from '@/components/ui/card'

/**
 * The company's event name format, as a venue's GoHighLevel page shows it. Every
 * venue uses the company's format, so it is shown here and changed on the
 * company's GoHighLevel page, by someone whose role reaches every venue.
 */
export function GhlNameFormatSummary({ nameFormat }: { nameFormat: string }) {
  const { user } = useAuth()
  return (
    <Card className="space-y-2 p-4">
      <p className="m-0 text-sm text-ink">
        For example: <span className="font-medium">{sampleName(nameFormat)}</span>
      </p>
      <p className="m-0 text-sm text-ink-muted">
        Every venue uses the same format.
        {reachesCompany(user) ? (
          <>
            {' '}
            <Link to="/gohighlevel" className="font-medium text-ink underline underline-offset-2">
              Change it for all venues
            </Link>
          </>
        ) : null}
      </p>
    </Card>
  )
}
